import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {t} from "react-switch-lang";
import EditImg from './img/edit.svg';
import modalBody from "./ModalData/ModalBody";
import returnDataTitle from './ModalData/DataTitle'
import './Modals.scss';
import {getAllExternalizationDocumentTemplates} from "../../services/externalizations/externalizationTemplatesServices";

export function Edit(props) {
    const [modal, setModal] = useState(false);
    const userModal = () => setModal(!modal);

    const body = () => {
        const MyComponent = modalBody(props.id).edit;
        if (MyComponent !== null) {
            return <MyComponent data={props.data}
                                toggleModal={() => setModal(false)}
                                setRowChanged={() => props.setRowChanged()}
                                fetchData={() => props.fetchData()}
            />
        } else {
            return ''
        }
    };

    return (
        <>
            {
                (props.data.activated === undefined || props.data.activated === true) &&
                <>
                    <Button className="primary modal-open-button"
                            onClick={userModal}>
                        <img src={EditImg} alt="icon"
                             style={{width: "11.2px", height: "14px"}}/>
                      
                        <span>{t('buttons.editBtn')}</span>
                    </Button>
                    <Modal isOpen={modal} toggle={userModal}
                           className="modal-lg" backdrop="static">
                        <ModalHeader toggle={userModal}>
                            <b>
                                {t('buttons.editBtn')}
                                <span>{returnDataTitle(props.id, props.data)}</span>
                                {/* <span>{returnDataTitle(props.id, props.data)}</span> */}
                            </b>
                        </ModalHeader>
                        <ModalBody>
                            {body()}
                        </ModalBody>
                    </Modal>
                </>
            }
        </>
    );
}
